import { Competition, Player, Sponsor, Team } from "./Index";
import { Model } from "./Model";

export interface Fixture extends Model {
	awayScore: number;
	captainSponsorId: number;
	captainSponsor: Sponsor;
	manOfTheMatchImage: string;
	firstHalfAdditional: number;
	fixtureDateTime: Date;
	homeScore: number;
	htDrawSponsorId?: number | null;
	htDrawShowSponsor?: boolean;
	htDrawFirst: number;
	htDrawFirstPrize: number;
	htDrawSecond: number;
	htDrawSecondPrize: number;
	htDrawThird: number;
	htDrawThirdPrize: number;
	manOfTheMatchId: number;
	manOfTheMatch: Player;
	matchAttendance: number;
	matchAwayAttendance: number;
	matchballSponsorId: number;
	matchballSponsor: Sponsor;
	matchSponsorId:number
	matchSponsor: Sponsor;
	programmeSponsorId:number
	programmeSponsor: Sponsor;
	secondHalfAdditional: number;
	/** Length of each half in minutes (blank = 45). */
	minutesPerHalf: number;
	/** Planned kicks per team in a shootout (blank = 5). */
	penaltyShots: number;
	teamId: number;
	team: Team;
	/** Which competition this fixture is in. Blank = uncategorised, and covered by no season ticket. */
	competitionId: number;
	/** Which season this fixture counts towards. Blank = uncategorised. */
	seasonId: number;
	/** Price category the fixture is sold at. Blank falls back to the club default. */
	ticketTemplateId: number;
	competition: Competition;
	referee: string;
	linesmanOne: string;
	linesmanTwo: string;
	fourthOfficial: string;
}

export class Fixture implements Fixture {
	awayScore = 0;
	firstHalfAdditional = 0;
	fixtureDateTime = new Date();
	homeScore = 0
	htDrawFirst = 0;
	htDrawFirstPrize = 0;
	htDrawSecond = 0;
	htDrawSecondPrize = 0;
	htDrawThird = 0;
	htDrawThirdPrize = 0;
	matchAttendance = 0;
	matchAwayAttendance = 0;
	secondHalfAdditional = 0;

	constructor(data?: Partial<Fixture>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}